// src/pages/Dashboard.jsx

import { useBlogs } from "../../contexts/blog/BlogContext";

export default function Dashboard() {
  const {blogStats,statsLoading,statsError}=useBlogs();
  // icons function
  const getStatIcon = (iconName) => {
    const icons = {
      building: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-3 4h1m-1 4h1"
          />
        </svg>
      ),
      home: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
      users: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
          />
        </svg>
      ),
      "file-text": (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      ),
    };
    return icons[iconName] || icons.building;
  };

  // stats data
  const stats = [
    {
      title: "Total Blogs",
      value: blogStats?.totalBlogs,
      change: "+12%",
      icon: "building",
      color: "from-blue-500 to-blue-600",
      link: "/dashboard/properties",
    },
    {
      title: "Draft Blogs",
      value: blogStats?.draftBlogs,
      change: "+23%",
      icon: "users",
      color: "from-purple-500 to-purple-600",
      link: "/dashboard/inquiries",
    },
    {
      title: "Published Blogs",
      value: blogStats?.publishedBlogs,
      change: "+15%",
      icon: "file-text",
      color: "from-orange-500 to-orange-600",
      link: "/dashboard/blogs",
    },
    {
      title: "Scheduled Blogs",
      value: blogStats?.scheduledBlogs,
      change: "+15%",
      icon: "file-text",
      color: "from-orange-500 to-orange-600",
      link: "/dashboard/blogs",
    },
  ];

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <div
            key={stat.title}
            className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 p-6 cursor-pointer"
            style={{
              animation: `fadeInUp 0.6s ease-out ${index * 0.1 + 0.2}s both`,
            }}
            // onClick={() => (window.location.href = stat.link)}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                {/* <p className="text-sm text-green-600 font-medium">{stat.change} from last month</p> */}
              </div>
              <div className={`p-3 rounded-full bg-gradient-to-r ${stat.color}`}>
                <div className="w-6 h-6 text-white">{getStatIcon(stat.icon)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div
        className="bg-white rounded-lg shadow-lg p-6"
        style={{
          animation: "fadeInUp 0.6s ease-out 0.8s both",
        }}
      >
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Quick Actions</h3>
          <p className="text-sm text-gray-600">Frequently used actions to manage your business</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {/* Add Blog */}
          <div
            className="flex flex-col items-center p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg hover:from-blue-100 hover:to-blue-200 transition-all duration-200 cursor-pointer group"
            onClick={() => (window.location.href = "/dashboard/blog/post")}
          >
            <div className="p-3 bg-blue-500 rounded-full mb-3 group-hover:scale-110 transition-transform duration-200">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-700">Publish Blog</span>
          </div>

          {/* Scheduled Blog */}
          <div
            className="flex flex-col items-center p-4 bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg hover:from-orange-100 hover:to-orange-200 transition-all duration-200 cursor-pointer group"
            onClick={() => (window.location.href = "/dashboard/blog/post")}
          >
            <div className="p-3 bg-orange-500 rounded-full mb-3 group-hover:scale-110 transition-transform duration-200">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-700">Schedule Blog</span>
          </div>

          {/* View Inquiries */}
          {/* <div
            className="flex flex-col items-center p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg hover:from-purple-100 hover:to-purple-200 transition-all duration-200 cursor-pointer group"
            onClick={() => (window.location.href = "/dashboard/inquiries")}
          >
            <div className="p-3 bg-purple-500 rounded-full mb-3 group-hover:scale-110 transition-transform duration-200">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-700">View Inquiries</span>
          </div> */}

          {/* Edit Profile */}
          {/* <div
            className="flex flex-col items-center p-4 bg-gradient-to-br from-green-50 to-green-100 rounded-lg hover:from-green-100 hover:to-green-200 transition-all duration-200 cursor-pointer group"
            onClick={() => (window.location.href = "/dashboard/website-settings")}
          >
            <div className="p-3 bg-green-500 rounded-full mb-3 group-hover:scale-110 transition-transform duration-200">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-700">Edit Profile</span>
          </div> */}
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
